import { FlowStepData } from "../FlowStepData";

export class RunRuleSet extends FlowStepData {
    readonly __type: string = "run_rule_set";

    constructor() {
        super();
        this.name = "Run Rule Set";
    }
}
